// JOBE-0044.14: hard-error variant — the sixth state spec carries for
// state-machine completeness (out of R9's five). Fires when fetch
// errors AND no cache entry exists. Final copy / treatment belongs to
// JOBE-0044.7's pass.

export function HardErrorState({ error, onRetry }) {
  const status = error && typeof error.status === 'number' ? error.status : 0;
  let msg = "Couldn't load the Library.";
  if (status === 400) msg = 'That filter set is invalid.';
  if (status === 401) msg = 'Please sign in to view the library.';
  if (status === 503) msg = 'The graph backend is unavailable right now.';

  return (
    <div
      className="library-table-empty library-state-hard-error"
      data-state="error"
    >
      <p className="library-state-hard-error-body">{msg}</p>
      {onRetry && (
        <button
          type="button"
          className="library-table-retry"
          onClick={onRetry}
        >
          Try again
        </button>
      )}
    </div>
  );
}
